<script setup lang="ts">
import { ref } from 'vue'
import { PlusIcon } from '@heroicons/vue/24/outline'
import type { IConsolidatedReport } from '@/interfaces/entities/management'
import { useManagementStore } from '@/store/management'
import ConsolidatedQueryDialog from './ConsolidatedQueryDialog.vue'
import ConsolidatedReport from './ConsolidatedReport.vue'

const store = useManagementStore()
const dialogOpen = ref(false)

function onAdd(report: IConsolidatedReport) {
  store.addConsolidatedReport(report)
  dialogOpen.value = false
}
</script>

<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between gap-2">
      <p class="text-sm text-slate-500">
        Consultas consolidadas por mês — empilhadas e salvas no navegador.
      </p>
      <button
        type="button"
        class="flex items-center gap-1 border border-primary bg-primary px-3 py-2 text-sm font-medium text-white hover:bg-primary/90"
        @click="dialogOpen = true">
        <PlusIcon class="h-4 w-4" /> Nova consulta
      </button>
    </div>

    <div
      v-if="!store.consolidatedReports.length"
      class="flex min-h-[220px] items-center justify-center border border-dashed border-stroke bg-white text-center text-sm text-slate-400">
      Nenhuma consulta. Clique em "Nova consulta" para escolher área/sensor, período e as colunas (consumo, custo,
      demanda, temperatura, alarmes).
    </div>

    <ConsolidatedReport
      v-for="report in store.consolidatedReports"
      :key="report.id"
      :report="report"
      @remove="store.removeConsolidatedReport(report.id)" />

    <ConsolidatedQueryDialog :is-open="dialogOpen" @cancel="dialogOpen = false" @add="onAdd" />
  </div>
</template>
